'use client'
import type { JSX } from 'react'
import { cn } from '@/lib/utils'
import {
  AnimatePresence,
  motion,
  useMotionValueEvent,
  useScroll,
} from 'framer-motion'
import { useState } from 'react'
import { Link } from 'react-router-dom'

export function FloatingNav({
  navItems,
  className,
  children,
}: {
  navItems: {
    name: string
    link: string
    icon?: JSX.Element
  }[]
  children: JSX.Element
  className?: string
}) {
  const { scrollYProgress } = useScroll()

  const [visible, setVisible] = useState(true)

  useMotionValueEvent(scrollYProgress, 'change', (current) => {
    // Check if current is not undefined and is a number
    if (typeof current === 'number') {
      const direction = current! - scrollYProgress.getPrevious()!
      if (current <= 0) {
        setVisible(true)
      }
      else if (scrollYProgress.get() < 0.05) {
        setVisible(false)
      }
      else {
        if (direction <= 0) {
          setVisible(true)
        }

        else {
          setVisible(false)
        }
      }
    }
  })

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{
          opacity: 1,
          y: -100,
        }}
        animate={{
          y: visible ? 0 : -100,
          opacity: visible ? 1 : 0,
        }}
        transition={{
          duration: 0.3,
        }}
        className={cn(
          'flex w-fit md:w-1/2 md:px-9 bg-inherit px-5 fixed top-6 inset-x-0 mx-auto dark:border-white/[0.2] rounded-full dark:bg-black shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)] z-[5] md:py-4 py-3 items-center justify-between gap-x-3',
          className,
        )}
      >
        <div className="flex items-center justify-around flex-1 gap-4 overflow-auto">
          {navItems.map((navItem: any, idx: number) => (
            <Link
              key={`link=${idx}`}
              to={navItem.link}
              className={cn(
                'flex-shrink-0 dark:text-neutral-50 space-x-1 text-neutral-600 dark:hover:text-neutral-300 hover:text-neutral-500',
              )}
            >
              <span className="bloc sm:hidden">{navItem.icon}</span>
              <span className="font-semibold">{navItem.name}</span>
            </Link>
          ))}
        </div>
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
